<template>
    <el-drawer
        :title="formData.id ? '编辑运费模板' : '新增运费模板'" 
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="500px"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"               
                ref="formData"
                label-position="top"
                size="medium"
            >   
				<el-form-item prop="name" :rules='[{required: true, message: "请填写模板名称", trigger:"blur"}]'>
				    <span slot="label">模板名称: 
				    </span>
				    <el-input
				        v-model="formData.name"
				        placeholder="请输入模板名称"
				        size="medium"
				        maxlength="40"
				    ></el-input>
				</el-form-item>
				<el-form-item prop="freightFormat" :rules='[{required: true, message: "请填写运费价格", trigger:"blur"}]'>
				    <span slot="label">运费价格: <small class="color-info">支持精确到小数点后2位，0代表包邮,-1代表到付</small></span>				    
					<el-input-number style="width:100%" v-model="formData.freightFormat" :precision="2" controls-position="right" :min="-1" :max="99999999.99" size="medium" placeholder="请输入运费价格"></el-input-number>
				</el-form-item>				
                <el-form-item prop="content" label="绑定商品:">                    
					<div class="drawer-content">
					    <el-upload 
					        drag 
					        action
					        :http-request="uploadFile"					        
					        ref="upload"
					        accept=".xls, .xlsx"
					        :show-file-list="true"
					        :before-upload="beforeUpload"
					        :file-list="fileList"
					        :on-change="onChange"
					        :on-remove="onRemove"
					        :disabled="uploadLoading"
					    >
					        <i class="el-icon-upload"></i>
					        <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em>,覆盖上传完整列表</div>
					        <div class="el-upload__tip tips" slot="tip">
					            上传Excel文件，只需要一列商品ID即可（无需表头）</br>上传后会依据最新列表，更新当前模板绑定的商品<br>不在列表中的，非销售状态的商品，会跟当前模板解绑<br>不在列表中的，销售中的商品，不会跟当前模板解绑
					        </div>
					    </el-upload>					   	   
					</div>
                </el-form-item>
				
				
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading" :disabled="canSubmit"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {uploadFileTmp} from '@/assets/js/commonApi.js';
const defaultData = {    
    name:'',
	freightFormat:'',
	path:'',
	id:''
}

export default {
	props:{
	   data:{
	       type: String,
	       default: null
	   }
	},
	components:{},
    data(){
        return{			
            drawerShow: false,
            btnLoading: false,
            formData:{
                ...defaultData
            },
            
			downLoading:false,
			uploadLoading:false,
			fileList:[],
			canSubmit:false
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;            
            this.formData = {
                ...defaultData
            }
			this.fileList = []
        },
        show(row) {
			if(row){
				console.log(row)
				this.formData.id = row.id;
				this.formData.name = row.name
				this.formData.freightFormat = row.freightView == '到付' ? -1 : row.freightView == '包邮' ? 0 :  row.freightView
			}               
           this.drawerShow = true;
        },
		async uploadFile(req){
		
		    this.btnLoading = true;
		    this.uploadLoading = true;
		    const formData = new FormData();
		    formData.append('file', req.file);
		    
		    let filePath;
		    const res = await uploadFileTmp(formData).catch(err => {
		        this.$message({message: err.message, type: 'error'});
		    }).finally(() => {
		        this.uploadLoading = false;
		    });
		    const{state,msg,result} = res.data;
		    if (state == 1 && result) {
				console.log(result)
		        filePath = result.url;
				this.formData.path = filePath
				 this.btnLoading = false;
		    }else{
		        this.$message.error(msg || '上传失败');
		    }
		},
		onChange(file){
		    if( file ){
		        this.fileList = [{...file}]
		        this.canSubmit = false;
		    }else{
		        this.canSubmit = true;
		    }
		},
		onRemove(){
		    this.canSubmit = true;
		},
		beforeUpload(file){
		    const type = this.$utils.getFileType(file.name)
		    const isType = type === 'xls' || type === 'xlsx';
		    if (!isType) {
		        this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
		    }
		    return isType;
		},
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/freight/management/edit',
                        data: {
							...this.formData                                             
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
								this.$emit('onUpdate');
								this.close()                               
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.tips{
	margin-top: -5px;
	line-height: 18px;
}
</style>